import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { QueryExtraReducer } from './queryThunk';


export interface State {
  isEnquiring: boolean,
  loadingChat: boolean,
  loadingPinned: boolean,
  enquireText: string,
  messages: any[],
  pinnedMessages: any[],
}

const initialState: State = {
  messages: [],
  pinnedMessages: [],
  isEnquiring: false,
  loadingChat: false,
  loadingPinned: false,
  enquireText: ''
};

export const querySlice = createSlice({
  name: 'query',
  initialState,
  reducers: {
    setEnquireText: (state, action: PayloadAction<string>) => { state.enquireText = action.payload },
    addMessage: (state, action: PayloadAction<any>) => { state.messages.push(action.payload) },
    setMessages: (state, action: PayloadAction<any[]>) => { state.messages = action.payload }
  },

  extraReducers: (builder) => {
    QueryExtraReducer(builder);
  }
});

export const { setEnquireText, addMessage, setMessages } = querySlice.actions;

export const selectIsEnquiring = (state: RootState) => state.query.isEnquiring;
export const selectEnquireText = (state: RootState) => state.query.enquireText;
export const selectMessages = (state: RootState) => state.query.messages;

export default querySlice.reducer;
